var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "skew-11-neg",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    attrs: {
      "id": "header__content"
    }
  }, [_c('ul', {
    attrs: {
      "id": "header__content-nav-list"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "id": "header__content-bio",
      "to": "/"
    }
  }, [_vm._v("Bio")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "id": "header__content-academics",
      "to": "academics"
    }
  }, [_vm._v("Academics")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "id": "header__content-hobbies",
      "to": "hobbies"
    }
  }, [_vm._v("Hobbies")])], 1)]), _vm._v(" "), _c('h1', {
    attrs: {
      "id": "header__content-name"
    }
  }, [_vm._v("Graham Bartley")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "header__content-desc"
    }
  }, [_vm._v("Senior Software Engineer | Technical Lead | M.Sc. in Secure Software Engineering Student")])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c8c8334","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MyHeader.vue
// module id = KdtA
// module chunks = 0